export default __webpack_public_path__ + "static/media/congrats.94ee917a.png";